import {
  FileInputRenderer,
  type FileInputRendererProps,
  getRendererProps,
} from '@exam-center/components';
import { Flex, SectionTitle, Text } from '@shared/components';

export interface ProctorDocumentFieldsProps {
  alertAdornment?: React.ReactNode;
  fields: {
    agreementForms: FileInputRendererProps;
    identifications?: FileInputRendererProps;
  };
  hideIdentificationFiles?: boolean;
}

export default function ProctorDocumentFields(props: Readonly<ProctorDocumentFieldsProps>) {
  const { alertAdornment, fields, hideIdentificationFiles } = props;
  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(6), flexDirection: 'column' })}>
      <SectionTitle title='File Document' />
      {alertAdornment}
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text variant='body1Semibold' sx={{ flexBasis: '240px' }}>
          เอกสารสำคัญ
        </Text>
        <Flex
          sx={(theme) => ({ gap: theme.spacing(6), flexDirection: 'column', flexBasis: '600px' })}
        >
          <FileInputRenderer
            {...getRendererProps(fields.agreementForms, {
              label: 'แบบฟอร์มข้อตกลงก่อนปฏิบัติหน้าที่ผู้คุมสอบ',
              placeholder: 'กรุณาอัปโหลดไฟล์ .JPG หรือ .JPEG หรือ .PNG หรือ .PDF',
              required: true,
            })}
          />
          {!hideIdentificationFiles && fields.identifications ? (
            <FileInputRenderer
              {...getRendererProps(fields.identifications, {
                label: 'เอกสารยืนยันตัวตน',
                placeholder: 'กรุณาอัปโหลดไฟล์ .JPG หรือ .JPEG หรือ .PNG หรือ .PDF',
                required: true,
              })}
            />
          ) : null}
        </Flex>
      </Flex>
    </Flex>
  );
}
